import React from "react";
import { Imgs, Line, Text, Wrapper } from "./SketchWalletPay.style";
export const SketchWalletPay = () => {
  return (
    <Wrapper>
      <Text.Wrapper>
        <Text.Container>
          <Text.Number>
            <span>첫 </span>
            번째
          </Text.Number>
          <Text.Title>앱 업데이트</Text.Title>
          <Text.Text>기존 사용하던 [구 스케치 월렛], [구 스케치 페이] 앱을 업데이트 합니다.</Text.Text>
        </Text.Container>
        <Text.Container>
          <Text.Number>
            <span>두 </span>
            번째
          </Text.Number>
          <Text.Title>앱 다운로드</Text.Title>
          <Text.Text>
            Play Store, App Store 로 이동해 '스케치 월렛' 을 검색한 뒤 신규 [스케치 월렛] 을 다운로드 받습니다.
          </Text.Text>
        </Text.Container>
        <Text.Container>
          <Text.Number>
            <span>세 </span>
            번째
          </Text.Number>
          <Text.Title>지갑생성 및 회원가입</Text.Title>

          <Text.ListText>- 첫 실행 후 '지갑 생성' 과 '회원가입'을 진행합니다.</Text.ListText>
          <Text.ListText>- 기존 회원과 동일한 이름, 연락처로 생성합니다.</Text.ListText>
          <Text.ListText>- 생성된 지갑 주소를 복사합니다.</Text.ListText>
        </Text.Container>
        <Text.Container>
          <Text.Number>
            <span>네 </span>
            번째
          </Text.Number>
          <Text.Title>스케치 스왑 시작하기</Text.Title>
          <Text.Text>사용하던 [구 스케치 월렛], [구 스케치 페이]에 접속합니다.</Text.Text>
        </Text.Container>
        <Text.Container>
          <Text.Number>
            <span>다섯 </span>
            번째
          </Text.Number>
          <Text.Title>스왑버튼 클릭</Text.Title>
          <Text.Text>
            <div>앱 내 SKET를 확인할 수 있는 페이지로 이동해</div>
            <div>활성화 되어있는 '뉴스케치 스왑' 버튼을 클릭합니다.</div>
          </Text.Text>
        </Text.Container>
        <Text.Container>
          <Text.Number>
            <span>여섯 </span>
            번째
          </Text.Number>
          <Text.Title>지갑 주소 입력하기</Text.Title>
          <Text.Text>
            <div>'스왑 받을 지갑 주소' 항목에 신규 [스케치 월렛]에서</div>
            <div>생성한 지갑 주소를 입력한 뒤 동의 체크를 선택합니다.</div>
          </Text.Text>
        </Text.Container>
        <Text.Container>
          <Text.Number>
            <span>일곱 </span>
            번째
          </Text.Number>
          <Text.Title>수량 정확히 입력</Text.Title>
          <Text.Text>'신청 수량'을 클릭해 스왑할 코인의 수량을 선택합니다.</Text.Text>
        </Text.Container>
        <Text.Container>
          <Text.Number>
            <span>여덟 </span>
            번째
          </Text.Number>
          <Text.Title>스왑 신청 완료</Text.Title>
          <Text.Text>내용을 다시 한번 확인한 뒤 '수수료 계산'과 '스왑 신청'을 완료합니다.</Text.Text>
        </Text.Container>
      </Text.Wrapper>
      <Line.Wrapper>
        <img src="/assets/img/swap_line.png" alt="line" />
        <div>STEP 1</div>
        <div>STEP 2</div>
        <div>STEP 3</div>
        <div>STEP 4</div>
        <div>STEP 5</div>
        <div>STEP 6</div>
        <div>STEP 7</div>
        <div>STEP 8</div>
      </Line.Wrapper>
      <Imgs.Wrapper>
        <img src="/assets/video/img_1.gif" alt="animation1" />
        <img src="/assets/img/swap_1.png" alt="swapImg1" />
        <img src="/assets/video/img_2.gif" alt="animation2" />
        <img src="/assets/img/swap_2.png" alt="swapImg2" />
        <img src="/assets/video/img_3.gif" alt="animation3" />
        <img src="/assets/img/swap_3.png" alt="swapImg3" />
        <img src="/assets/img/swap_4.png" alt="swapImg4" />
        <img src="/assets/video/img_4.gif" alt="animation4" />
      </Imgs.Wrapper>
    </Wrapper>
  );
};
